import request from '@/utils/request'

export function fetchList(query) {
    return request({
        url: '/admin/logisticsCompany/list',
        method: 'get',
        params: query
    })
}

export function saveOrUpdate(data) {
    return request({
        url: '/admin/logisticsCompany/saveOrUpdate',
        method: 'post',
        data
    })
}

export function selectList() {
    return request({
        url: '/admin/logisticsCompany/selectList',
        method: 'get'
    })
}


export function selectAll() {
    return request({
        url: '/admin/logisticsCompany/selectAll',
        method: 'get'
    })
}

export function deleteLogisticsCompany(id) {
  return request({
    url: '/admin/logisticsCompany/delete',
    method: 'get',
    params: { id }
  })
}